var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30889 5.29289C8.72073 4.90237 9.38847 4.90237 9.80032 5.29289L15.3822 10.5858C16.2059 11.3668 16.2059 12.6332 15.3822 13.4142L9.80032 18.7071C9.38847 19.0976 8.72073 19.0976 8.30889 18.7071C7.89704 18.3166 7.89704 17.6834 8.30889 17.2929L13.8908 12L8.30889 6.70711C7.89704 6.31658 7.89704 5.68342 8.30889 5.29289Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.d197e4514324b3e2cc6672e9aeb10264.svg";
export { ForwardRef as ReactComponent };